// The item D fixtures, loaded on demand (a separate chunk, so they don't add
// to the startup bundle until a scene asks for them).
// Criterion #8's three fixtures (item D).
export const FIXTURE_NAMES = ['war-s23-r29', 'war-s23-r30', 'war-s23-r31']
// The reveal beat's fixture (item C): a bot-war round whose corridor-5 clash
// lands a full four-ring crater; its state meets item B's minimums. This is
// the graded war scene.
export const REVEAL_FIXTURE = 'reveal-s3-r17'
export const SCENE_NAMES = [REVEAL_FIXTURE, ...FIXTURE_NAMES]
export const DEFAULT_FIXTURE = REVEAL_FIXTURE

export function loadFixture(name) {
    switch (name) {
        case 'war-s23-r29': return import(/* webpackChunkName: "fixture-r29" */ '../fixtures/war-s23-r29.json').then(m => m.default)
        case 'war-s23-r30': return import(/* webpackChunkName: "fixture-r30" */ '../fixtures/war-s23-r30.json').then(m => m.default)
        case 'war-s23-r31': return import(/* webpackChunkName: "fixture-r31" */ '../fixtures/war-s23-r31.json').then(m => m.default)
        case 'reveal-s3-r17': return import(/* webpackChunkName: "fixture-reveal" */ '../fixtures/reveal-s3-r17.json').then(m => m.default)
        default: return Promise.reject(new Error(`unknown fixture ${name}`))
    }
}
